import { StorageService } from '@chew/common/services/storage';

export const storage = new StorageService('chew-app');
